module.exports = __webpack_public_path__ + "4180330c70d288e2f72ee1f62e8b988f.svg";